<template>
    <div class="wrap">
        <div class="boxCard">
            <el-card class="box-card" :body-style="{padding: '0'}">
                <div slot="header" class="clearfix">
                    <span>代购订单</span>
                    <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                </div>
                <el-form :inline="true" :model="queryParams" ref="queryParams" class="demo-form-inline">
                    <el-form-item label="姓名" prop="buyPerson">
                        <el-input v-model="queryParams.buyPerson" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码" prop="contactPhone">
                        <el-input v-model="queryParams.contactPhone" placeholder="请输入手机号码"></el-input>
                    </el-form-item>
                    <el-form-item label="药品名" prop="drugName">
                        <el-input v-model="queryParams.drugName" placeholder="请输入药品名"></el-input>
                    </el-form-item>
                    <el-form-item label="取货方式" prop="pickWays">
                        <el-select v-model="queryParams.pickWays" placeholder="请选择取货方式">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="自提" value="2"></el-option>
                            <el-option label="快递" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getOrderList('click')">查询</el-button>
                        <el-button @click="resetForm('queryParams')">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
        <div class="boxCard tabBox">
            <el-card class="box-card" :body-style="{padding: '0'}">
                <div slot="header">
                    <!-- <span class="tabTitle">门店列表</span> -->
                    <el-button type="primary" @click="showDialog('1')" class="addOrder">新增订单</el-button>
                    <!-- <el-radio-group v-model="queryParams.state" size="medium">
                        <el-radio-button label="0">全部</el-radio-button>
                        <el-radio-button label="1">待处理</el-radio-button>
                        <el-radio-button label="2">待支付</el-radio-button>
                        <el-radio-button label="3">已支付</el-radio-button>
                        <el-radio-button label="4">已取消</el-radio-button>
                        <el-radio-button label="5">已完成</el-radio-button>
                    </el-radio-group> -->
                    <el-tabs v-model="queryParams.state" @tab-click="tabChange">
                        <el-tab-pane label="全部" name="0"></el-tab-pane>
                        <el-tab-pane label="待处理" name="1"></el-tab-pane>
                        <el-tab-pane label="待支付" name="2"></el-tab-pane>
                        <el-tab-pane label="已支付" name="3"></el-tab-pane>
                        <el-tab-pane label="待取货" name="4"></el-tab-pane>
                        <el-tab-pane label="已完成" name="5"></el-tab-pane>
                        <el-tab-pane label="已取消" name="6"></el-tab-pane>
                        <el-tab-pane label="待支付" name="7"></el-tab-pane>
                    </el-tabs>
                </div>
                <el-table :data="tableData" show-header border style="width: 100%">
                    <el-table-column type="index" align="center" label="序号" />
                    <el-table-column prop="buyPerson" align="center" label="姓名" />
                    <el-table-column prop="contactPhone" align="center" label="手机号码" />
                    <el-table-column prop="selfStoreArea" align="center" label="所在地区">
                        <template slot-scope="scope">{{(scope.row.selfStoreArea ||'').replace(/,/g,'')}}</template>
                    </el-table-column>
                    <el-table-column prop="drugName" align="center" label="代购药名称" />
                    <el-table-column prop="manufacturer" align="center" label="生产厂家" />
                    <el-table-column prop="agentCount" align="center" label="数量" />
                    <el-table-column prop="orderMeney" align="center" label="订单金额（元）" />
                    <el-table-column prop="pickWays" :formatter="pickWaysFormat" align="center" label="取货方式" />
                    <el-table-column prop="isChange" :formatter="isChangeFormat" align="center" label="是否接受替代厂家" />
                    <el-table-column prop="orderStatus" :formatter="statusFormat" align="center" label="状态" />
                    <el-table-column prop="pickupNum" align="center" label="取货码" />
                    <el-table-column label="操作" align="left" fixed="right" width="250">
                        <template slot-scope="scope">
                            <!-- <el-button size="mini" type="primary" @click="isShow = true">处理报价</el-button> -->
                            <!-- <el-button size="mini" type="primary" @click="isShow = true">物流信息</el-button> -->
                            <el-button size="mini" @click="toDetail(scope.row)">详情</el-button>
                            <el-button size="mini" type="success" @click="showDialog('2',scope.row)" v-if="scope.row.orderStatus !== 5 && scope.row.orderStatus !== 4">编辑</el-button>
                            <el-button size="mini" type="primary" v-if="scope.row.orderStatus === 2 && scope.row.pickWays === 2" @click="sendMsg(scope.row)">通知收货</el-button>
                            <el-button size="mini" type="primary" v-if="scope.row.orderStatus === 3 && scope.row.pickWays === 2" @click="checkOrderStatus(scope.row)">确认收货</el-button>

                            <el-button size="mini" type="primary" v-if="scope.row.orderStatus === 2 && scope.row.pickWays === 1" @click="logisticsOpen(scope.row)">物流信息</el-button>
                            <el-button size="mini" type="success" @click="toUpMoney(scope.row)" v-if="scope.row.orderStatus === 6">提交报价</el-button>
                            <el-button size="mini" type="danger" @click="delTabItem(scope.row.orderNo)" v-if="scope.row.orderStatus === 1 || scope.row.orderStatus === 6 || scope.row.orderStatus === 7">取消</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="pageNum" :page-size="pageSize" @size-change="barSizeChange" @current-change="barCurrentChange" :page-sizes="[10, 20, 30, 40, 50]" background="" layout="sizes, prev, pager, next" :total="totalCount"></el-pagination>
            </el-card>
        </div>
        <my-from-dialog :isShow="isShow" :title="dialogTitle" @cancel="closeDialog" @ok="okDialog" @closeCallBack="closeCbDialog" :isFullscreen="true" :scrollHeight="''" :cancelText="'取消'" :okBtnText="dialogOkBtnText">
            <template slot="froms">
                <el-divider content-position="left" class="myDivider">代购信息</el-divider>
                <el-form :model="form" :rules="rules" ref="form" label-width="140px">
                    <el-form-item label="联系人" prop="buyPerson">
                        <el-input v-model="form.buyPerson" placeholder="请输入联系人" class="baseInp"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="contactPhone">
                        <el-input v-model="form.contactPhone" placeholder="请输入联系电话" class="baseInp"></el-input>
                    </el-form-item>
                    <el-form-item label="药品名称" prop="drugName">
                        <!-- <el-input v-model="form.value" placeholder="请输入药品名称" class="baseInp"></el-input> -->
                        <!-- <el-select v-model="form.drugName" filterable remote :remote-method="getDrugList" placeholder="请选择药品" class="baseInp">
                            <el-option v-for="(item,index) in drugList" :key="index" :label="item.drugName" :value="index" />
                        </el-select> -->
                        <el-select v-model="form.drugName" filterable placeholder="请选择药品" @change="getDrugId" remote :remote-method="remoteMethod" :loading="selectLoading" class="baseInp input-all" @visible-change="changeArrow" :class="{'el-icon-arrow-down':arrowDownState === false,'el-icon-arrow-up':arrowDownState === true}">
                            <el-option v-for="(item,index) in drugInfoList" :key="index" :label="item.drugName" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="生产厂家" prop="manufacturer">
                        <el-input v-model="form.manufacturer" placeholder="请输入生产厂家" class="baseInp"></el-input>
                    </el-form-item>
                    <el-form-item label="数量" prop="agentCount">
                        <!-- <el-input v-model="form.value" placeholder="请输入生产厂家" class="baseInp"></el-input> -->
                        <el-input-number v-model="form.agentCount" placeholder="请输入数量" @change="changeInpNum" :min="1" :max="10" label="数量"></el-input-number>
                    </el-form-item>
                    <el-form-item label="是否接受代替厂家" prop="isChange">
                        <el-radio-group v-model="form.isChange" size="mini">
                            <el-radio label="1">是</el-radio>
                            <el-radio label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="订单金额（元）" prop="orderMeney">
                        <el-input v-model="form.orderMeney" placeholder="请输入订单金额" type="number" class="baseInp" :disabled="form.orderStatus == '1' && dialogType == '2'"></el-input>
                    </el-form-item>
                    <el-divider content-position="left" class="myDivider">收货信息</el-divider>
                    <el-form-item label="取货方式" prop="pickWays">
                        <el-radio-group v-model="form.pickWays" size="mini">
                            <el-radio label="2">自提</el-radio>
                            <!-- <el-radio label="1">快递</el-radio> -->
                        </el-radio-group>
                    </el-form-item>
                    <div class="ziti" v-if="pickWaysType == '2'">
                        <!-- <el-form-item label="提货地址"> -->
                        <!-- <AreaSelectPicker ref="areaSelectPicker" class="input-all" /> -->
                        <!-- const { province, city, area, areaCode } = this.$refs.areaSelectPicker.selectItem;
                        console.log('province, city, area, areaCode', province, city, area, areaCode); -->
                        <!-- </el-form-item> -->
                        <el-form-item label="提货门店" prop="storeName" ref="storeName">
                            <!-- <el-input v-model="form.value" placeholder="请输入药品名称" class="baseInp"></el-input> -->
                            <el-select v-model="form.storeName" filterable placeholder="请选择门店" @change="getStoreId" class="baseInp">
                                <el-option v-for="(item,index) in storeList" :key="index" :label="item.storeName" :value="item" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="门店地址" prop="storeAddress" ref="storeAddress">
                            <el-input v-model="form.storeAddress" class="baseInp" disabled></el-input>
                        </el-form-item>
                    </div>
                    <div class="kuaidi" v-if="pickWaysType == '1'">
                        <el-form-item label="收货人" prop="receiver" ref="receiver">
                            <el-input v-model="form.receiver" placeholder="请输入收货人" class="baseInp"></el-input>
                        </el-form-item>
                        <el-form-item label="收货人电话" prop="receiverPhone" ref="receiverPhone">
                            <el-input v-model="form.receiverPhone" placeholder="请输入收货人电话" class="baseInp"></el-input>
                        </el-form-item>
                        <el-form-item label="收货地址">
                            <AreaSelectPicker ref="areaSelectPicker" class="input-all" :preSelectItem="preSelectItem" />
                        </el-form-item>
                        <el-form-item label="详细地址" prop="receiverAddress" ref="receiverAddress">
                            <el-input v-model="form.receiverAddress" placeholder="请输入详细地址" class="baseInp"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item label="备注">
                        <el-input v-model="form.orderRemark" :rows="5" type="textarea" class="baseInp"></el-input>
                    </el-form-item>
                </el-form>
            </template>
        </my-from-dialog>
        <my-from-dialog :title="'订单详情'" :isShow="isShow2" :isFullscreen="true" :scrollHeight="''" :cancelText="'关闭'" :okBtn="false" @cancel="closeDialog2" @closeCallBack="closeCbDialog2">
            <template slot="froms">
                <el-divider content-position="left" class="myDivider">订单信息 <span class="state">状态:{{statusFormat2((form2.orderStatus+'')||'')}}</span></el-divider>
                <el-form :model="form2" label-width="130px">
                    <el-form-item label="药品名称">{{form2.drugName ||''}}</el-form-item>
                    <el-form-item label="生产厂家">{{form2.manufacturer ||''}}</el-form-item>
                    <el-form-item label="数量">{{form2.agentCount ||''}}</el-form-item>
                    <el-form-item label="是否接受代替厂家">{{form2.isChange == '1' ? '是':'否'}}</el-form-item>
                    <el-form-item label="订单金额（元)">{{form2.orderMeney ||''}}</el-form-item>
                    <el-form-item label="代购人姓名">{{form2.buyPerson ||''}}</el-form-item>
                    <el-form-item label="联系电话">{{form2.contactPhone ||''}}</el-form-item>
                </el-form>
                <el-divider content-position="left" class="myDivider">收货信息</el-divider>
                <el-form :model="form" label-width="130px">
                    <el-form-item label="取货方式">{{form2.pickWays === 2 ? '自提':'快递'}}</el-form-item>
                    <div class="ziti" v-if="form2.pickWays === 2">
                        <el-form-item label="提货地区">{{form2.selfStoreArea ||''}}</el-form-item>
                        <el-form-item label="自提门店">{{form2.selfStoreName ||''}}</el-form-item>
                        <el-form-item label="门店地址">{{form2.selfStoreAddress ||''}}</el-form-item>
                        <el-form-item label="门店电话">{{form2.selfStorePhone ||''}}</el-form-item>
                    </div>
                    <div class="kuaidi" v-if="form2.pickWays === 1">
                        <el-form-item label="收货人">{{form2.receiver ||''}}</el-form-item>
                        <el-form-item label="联系电话">{{form2.receiverPhone ||''}}</el-form-item>
                        <el-form-item label="收货地址">{{(form2.selfStoreArea||'').replace(/,/g,'') + form2.receiverAddress ||''}}</el-form-item>
                    </div>

                    <el-form-item label="备注">{{form2.orderRemark ||''}}</el-form-item>
                </el-form>
                <el-divider content-position="left" class="myDivider">收货信息</el-divider>
                <el-form :model="form" label-width="130px">
                    <el-form-item label="物流公司">{{form2.logisticsCompany ||''}}</el-form-item>
                    <el-form-item label="物流单号">{{form2.logisticsNo ||''}}</el-form-item>
                </el-form>
            </template>
        </my-from-dialog>
        <my-from-dialog :title="'物流信息'" :isShow="isShow3" :cancelText="'关闭'" :scrollHeight="'100px'" @ok="okDialog3" @cancel="closeDialog3" @closeCallBack="closeCbDialog3">
            <template slot="froms">
                <el-form :model="logistics" :rules="logisticsRule" ref="logistics" label-width="100px">
                    <el-form-item label="物流公司" prop="logisticsCompany">
                        <el-input v-model="logistics.logisticsCompany" placeholder="请输入联系人" class="baseInp"></el-input>
                    </el-form-item>
                    <el-form-item label="物流单号" prop="contactPhone">
                        <el-input v-model="logistics.logisticsNo" placeholder="请输入联系电话" class="baseInp"></el-input>
                    </el-form-item>
                </el-form>
            </template>
        </my-from-dialog>
    </div>
</template>

<script>
import myFromDialog from '@/components/common/from_dialog';
import myUpload from '@/components/common/upload';
import AreaSelectPicker from '@/components/common/AreaSelect';
import { objDeepCopy } from '@/utils/index';
let self = null;
export default {
    components: {
        myFromDialog,
        myUpload,
        AreaSelectPicker,
    },
    computed: {},
    watch: {
        // 'form.name': {
        //     handler: function () {
        //         //do something
        //     },
        // }
    },
    created() {
        this.loginData = JSON.parse(localStorage.getItem('loginData')) || {};
        this.getOrderList();
        // this.getDrugList();
        this.getDrugInfoPageList();
        this.getStoreList();
        self = this;
    },
    data() {
        return {
            isShow3: false,
            isShow2: false,
            isShow: false,
            visible: false,
            selectLoading: false,
            arrowDownState: false,
            drugInfoList: [],
            oldDrugInfoList: [],
            dialogType: '',
            dialogTitle: '新增门店',
            dialogOkBtnText: '提交报价',
            pageNum: 1,
            pageSize: 10,
            totalCount: 0,
            tableData: [],
            queryParams: {
                buyPerson: '',
                contactPhone: '',
                drugName: '',
                pickWays: '',
                state: '0',
                value: '',
            },
            form: {
                value: '',
                radioVal: '1',
                date1: '',
                date2: '',
                num: 0
            },
            form2: {},
            logistics: {
                logisticsCompany: '',
                logisticsNo: '',
            },
            drugList: [
                {
                    value: '1',
                    label: '999'
                },
                {
                    value: '1',
                    label: '1111'
                }
            ],
            loginData: {},
            storeList: [],
            preSelectItem: {
                province: '',
                city: '',
                area: '',
                areaCode: ''
            },
            pickWaysType: '',
            rules: this.getRules(),
            logisticsRule: this.getLogisticsRule(),
        }
    },
    methods: {
        getStoreId(item) {
            this.form.storeId = item.id;
            this.form.storeName = item.storeName;
            this.form.storeAddress = item.storeAddress;
            // this.form.receiverPhone = item.contactPhone;
        },
        getDrugId(item) {
            console.log(item);
            this.form.drugId = item.id;
            this.form.drugName = item.drugName;
            this.$set(this.form, 'manufacturer', item.manufacturer || '')
            // this.form.manufacturer = item.manufacturer;
            this.form.agentCount = 1;
        },
        toDetail(item) {
            console.log(item);
            // item.orderStatus = item.orderStatus+'';
            this.form2 = item;
            this.isShow2 = true;
        },
        changeArrow(state) {
            console.log(state);
            this.arrowDownState = state;
        },
        tabChange(tab, e) {
            this.pageNum = 1;
            console.log(tab, e, this.queryParams.state)
            this.getOrderList();
        },
        changeInpNum(val) {
            console.log(val);
        },
        closeDialog(data) {
            this.isShow = false;
            console.log(data);
        },
        okDialog(data) {
            console.log(data);
            if (this.dialogType == '1') {
                this.addOrder();
            } else {
                this.editOrder();
            }
            // this.isShow = false;
        },
        closeCbDialog(data) {
            console.log(data);
            this.isShow = false;
        },
        closeDialog2(data) {
            this.isShow2 = false;
            console.log(data);
        },
        closeCbDialog2(data) {
            console.log(data);
            this.isShow2 = false;
        },
        okDialog3() {
            this.editOrder2();
        },
        closeDialog3(data) {
            this.isShow3 = false;
            console.log(data);
        },
        closeCbDialog3(data) {
            console.log(data);
            this.isShow3 = false;
        },
        // 当前显示条数
        barSizeChange(val) {
            this.pageSize = val;
            this.getOrderList();
            // console.log(`每页 ${val} 条`);
        },
        // 当前页
        barCurrentChange(val) {
            this.pageNum = val;
            this.getOrderList();
            // console.log(`当前页: ${val}`);
        },
        //
        delTabItem(orderNo) {
            this.$confirm('是否确定取消该订单?', '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.cancelOrder(orderNo);
            }).catch(() => {
            });

        },
        initForm(item) {
            this.form = {};
            // this.memberFamilyList = [];
            // this.diseaseIdList = [];
            // this.diseaseHisList = [];
            // this.drugAllergyList = [];
            // this.inheritHisList = [];
            console.log(item);
            // this.useDrugHisList = [];
            this.preSelectItem = this.$set({ province: '', city: '', area: '', areaCode: '' });
            if (item) {
                let data = objDeepCopy(item);
                // let receiverPerson = data.receiverPerson.split(',') || [];
                let receiverPerson = data.selfStoreArea.split(',') || [];
                // let diseasePastId = (data.diseasePastId && data.diseasePastId.split(',')) || [];
                // let drugPastId = (data.drugPastId && data.drugPastId.split(',')) || [];
                // let inheritanceDiseasePastId = (data.inheritanceDiseasePastId && data.inheritanceDiseasePastId.split(',')) || [];
                // let usedDrugPastId = (data.usedDrugPastId && data.usedDrugPastId.split(',')) || [];
                this.form = data;
                this.form.pickWays = this.form.pickWays + '';
                this.pickWaysType = this.form.pickWays;
                this.form.isChange = this.form.isChange + '';
                this.form.storeName = this.form.selfStoreName || '';
                this.form.storeAddress = this.form.selfStoreAddress || '';
                // data.diseaseId = data.diseaseId || '';
                // this.diseaseIdList = data.diseaseId.split(',');
                // this.memberFamilyList = data.memberFamilyList || [];
                this.preSelectItem = { province: receiverPerson[0] || '', city: receiverPerson[1] || '', area: receiverPerson[2] || '', areaCode: '' };
                // // this.form.detailAddress = memberAddress[3];
                // this.$set(this.form, 'detailAddress', receiverPerson[3])
                // diseasePastId.map((d, i) => { this.diseaseHisList.push({ label: d }) });
                // drugPastId.map((d, i) => { this.drugAllergyList.push({ label: d }) });
                // inheritanceDiseasePastId.map((d, i) => { this.inheritHisList.push({ label: d }) });
                // usedDrugPastId.map((d, i) => { this.useDrugHisList.push({ label: d }) });
                // this.form.orderStatus = this.dialogType == '3'? 1 : this.form.orderStatus;
            }
        },
        // 显示弹框
        showDialog(dialogType, item) {
            let _this = this;
            this.dialogType = dialogType;
            // this.dialogTitle = dialogType == '1' ? '新增订单' : '编辑订单';
            this.dialogTitle = { '1': '新增订单', '2': '编辑订单', '3': '提交报价' }[dialogType];
            // this.dialogOkBtnText = dialogType == '1' ? '提交报价' : '保 存';
            this.dialogOkBtnText = { '1': '提交报价', '2': '保 存', '3': '提交报价' }[dialogType];
            this.isShow = true;
            this.$nextTick(() => {
                _this.$refs.form.clearValidate();
                _this.$refs.areaSelectPicker && _this.$refs.areaSelectPicker.$refs.areas.clearValidate();
            })
            this.initForm(item);
            // this.form.orderStatus = dialogType == '1' ? 2 : item.orderStatus;
            this.form.orderStatus = { '1': 2, '2': (item && item.orderStatus) || '', '3': 7 }[dialogType];
            setTimeout(() => {
                if (dialogType == '3') {
                    _this.$message.error('提交报价金额不能少于0元');
                }
            }, 100)
        },
        initLogisticsData(item) {
            this.logistics.orderMeney = item.orderMeney || '';
            this.logistics.logisticsCompany = item.logisticsCompany || '';
            this.logistics.logisticsNo = item.logisticsNo || '';
            this.logistics.orderNo = item.orderNo;
            this.logistics.enterpriseId = this.loginData.enterpriseId;
        },
        logisticsOpen(item) {
            console.log(item);
            let _this = this;
            this.isShow3 = true;
            this.initLogisticsData(item);
        },
        // 重置查询字段
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.queryParams.state = '0';
            this.getOrderList('click');
        },
        // 获取订单状态查询
        getOrderStatus(state) {
            return {
                '0': '',
                '1': '6', // 待处理
                '2': '1', // 待支付
                '3': '2', // 已支付
                '4': '3', // 待取货
                '5': '4', // 已完成
                '6': '5',  // 已取消
                '7': '7'  // 已取消
            }[state]
        },
        // 获取订单列表 - 请求
        getOrderList(str) {
            let _this = this;
            let queryParams = this.queryParams;
            let params = {
                buyPerson: queryParams.buyPerson,
                contactPhone: queryParams.contactPhone,
                drugName: queryParams.drugName,
                pickWays: queryParams.pickWays,
                orderStatus: this.getOrderStatus(queryParams.state),
                pageNum: str ? 1 : this.pageNum,
                enterpriseId: this.loginData.enterpriseId,
                needComPms: false,
                pageSize: this.pageSize
            }
            this.$https.post('system/agentOrder/list', params).then(res => {
                _this.tableData = res.rows || [];
                _this.totalCount = res.total || 0;
                console.log(res);
            }).catch(res => {

            })
        },
        setParams() {
            let flag = false;
            this.form.needComPms = false;
            this.form.enterpriseId = JSON.parse(localStorage.getItem('enterpriseInfo')).id;
            this.form.enterpriseName = JSON.parse(localStorage.getItem('enterpriseInfo')).enterpriseName;
            this.$refs.form.validate(valid => { flag = valid; });
            if (this.dialogType == '3' && (this.form.orderMeney - 0) <= 0) {
                this.$message.error('提交报价金额不能低于0元');
                return false;
            }
            if (flag) {
                let flag2 = false;
                if (this.pickWaysType == '1') {
                    flag2 = this.$refs.areaSelectPicker.validateForm();
                    if (this.pickWaysType == '1') {
                        const { province, city, area, areaCode } = this.$refs.areaSelectPicker.selectItem;
                        console.log('province, city, area, areaCode', province, city, area, areaCode);
                        this.form.receiverPerson = province + ',' + city + ',' + area;
                    }
                } else {
                    flag2 = true;
                }
                // console.log(flag);
                // flag = true;
                return flag2;
            } else {
                this.$message.error('提交信息不完整，请检查');
                return false;
            }
        },
        // 新增订单
        addOrder() {
            let _this = this;
            let bool = this.setParams();
            if (!bool) return;
            this.form.selfStoreArea = this.form.receiverPerson;
            this.form.selfStoreAddress = this.form.storeAddress;
            this.form.selfStoreId = this.form.storeId;
            let params = JSON.parse(JSON.stringify(this.form));
            if (localStorage.getItem('enterpriseType') != '1') {
                params.storeId = null;
                params.storeName = null;
            } else {
                params.storeId = JSON.parse(localStorage.getItem('loginData')).storeId;
                params.storeName = null;
            }
            this.$https.post('system/agentOrder/commitAgentOrder', params).then(res => {
                if (res.code === 200) {
                    _this.$message.success('新增订单成功');
                    _this.isShow = false;
                    _this.getOrderList();
                    console.log(res);
                } else {
                    _this.$message.error(res.msg || '接口请求异常');
                }
            }).catch(res => {
                // _this.$message.error(res.msg || '接口请求异常');
            })
        },
        // 编辑订单
        editOrder() {
            let _this = this;
            let bool = this.setParams();
            if (!bool) return;
            this.form.selfStoreArea = this.form.receiverPerson;
            this.form.selfStoreAddress = this.form.storeAddress;
            this.form.selfStoreId = this.form.storeId;
            let params = JSON.parse(JSON.stringify(this.form));
            if (localStorage.getItem('enterpriseType') != '1') {
                params.storeId = null;
                params.storeName = null;
            } else {
                params.storeId = JSON.parse(localStorage.getItem('loginData')).storeId;
                params.storeName = null;
            }
            this.$https.put('system/agentOrder/updateAgentOrder', params).then(res => {
                if (res.code === 200) {
                    _this.$message.success('修改订单成功');
                    _this.isShow = false;
                    _this.getOrderList();
                    console.log(res);
                } else {
                    _this.$message.error(res.msg || '接口请求异常');
                }
            }).catch(res => {
                // _this.$message.error('接口请求异常');
            })
        },
        setLogisticsParams() {
            let flag = false;
            this.$refs.logistics.validate(valid => { flag = valid; });
            if (flag) {
                return this.logistics;
            }
        },
        // 编辑物流信息
        editOrder2() {
            let _this = this;
            let params = this.setLogisticsParams();
            if (!params) return;
            this.$https.put('system/agentOrder/updateAgentOrder', params).then(res => {
                _this.$message.success('修改物流信息成功');
                _this.isShow3 = false;
                _this.getOrderList();
                console.log(res);
            }).catch(res => {
                // _this.$message.error('接口请求异常');
            })
        },
        toUpMoney(item) {
            let _this = this;
            if ((item.orderMeney - 0) <= 0) {
                this.showDialog('3', item);
                return;
            }
            // item.orderStatus = 7;
            this.$https.put('system/agentOrder/updateAgentOrder', item).then(res => {
                _this.$message.success('提交报价成功');
                // _this.isShow = false;
                _this.getOrderList();
                console.log(res);
            }).catch(res => {
                // _this.$message.error('接口请求异常');
            })
        },
        getSendMsgParams(item) {
            if (!item.selfStoreName) {
                this.$message.error('请补充收货信息门店名称');
                return;
            }
            if (!item.selfStoreAddress) {
                this.$message.error('请补充收货信息门店地址');
                return;
            }
            if (!item.contactPhone) {
                this.$message.error('请补充收货信息联系人电话');
                return;
            }
            return true;
        },
        // sendMsg
        sendMsg(item) {
            let _this = this;
            let bool = this.getSendMsgParams(item);
            if (!bool) return;
            let params = {
                phoneNumber: item.contactPhone,
                templatePurpose: 5,
                param1: item.selfStoreName,
                param2: item.selfStoreAddress,
                param3: item.pickupNum,
                param4: item.selfStorePhone,
                // storeName: item.storeName,
                // storeAddress: item.storeAddress,
                // storePhone: item.storePhone,
                // pickupNum: item.pickupNum
            }
            this.$https.smsPost('sms/blendSendSms', params).then(res => {
                if (res.code == 1) {
                    _this.$message.success('发送成功');
                    _this.updataOrderStatus({ orderNo: item.orderNo, orderStatus: '3' });
                } else {
                    _this.$message.success('发送失败');
                }
            }).catch(res => {

            })
        },
        checkOrderStatus(item) {
            this.updataOrderStatus({ orderNo: item.orderNo, orderStatus: '4' });
        },
        // 发送短信后更新订单状态
        updataOrderStatus(params) {
            let _this = this;
            this.$https.get('system/agentOrder/updateOrderStatus', params).then(res => {
                _this.getOrderList();
            }).catch(res => {

            })
        },
        // 获取药品列表
        // getDrugList() {
        //     this.$https.get('system/medicinal/getDrugInfoList', { drugName: this.form.drugName }).then(res => {
        //         console.log(res);
        //     }).catch(res => {
        //         _this.$message.success(res.data.msg || '接口请求异常');
        //     })
        // },
        // 获取门店列表
        getStoreList() {
            let _this = this;
            this.$https.get('system/store/findAll', { enterpriseId: this.loginData.enterpriseId }).then(res => {
                _this.storeList = res.data || [];
                console.log(res);
            }).catch(res => {

            })
        },
        // 取消订单
        cancelOrder(orderNo) {
            let _this = this;
            this.$https.post('system/agentOrder/cancelOrder/' + orderNo, {}).then(res => {
                // _this.storeList = res.rows || [];
                _this.getOrderList();
                // console.log(res);
                _this.$message.success('取消订单成功');
            }).catch(res => {

            })
        },
        //  获取药品列表
        getDrugInfoPageList(params) {
            var _this = this;
            this.$https.get('system/medicinal/getDrugInfoPage', params || {}).then(res => {
                _this.selectLoading = false;
                if (res.code == 200) {
                    _this.drugInfoList = res.rows || [];
                    _this.oldDrugInfoList = res.rows || [];
                } else {
                    _this.$message.error(res.msg || '请求失败');
                }
            })
                .catch(err => {
                    // _this.loading = false;
                    console.log(err);
                    // reject(error);
                });
        },
        // 药名搜索
        remoteMethod(val) {
            var _this = this;
            var flag = true;
            if (val !== '') {
                if (this.oldDrugInfoList.length > 0) {
                    this.drugInfoList = [];
                    var arr = [];
                    for (let i = 0; i < _this.oldDrugInfoList.length; i++) {
                        var drugItem = _this.oldDrugInfoList[i];
                        if (drugItem.drugName.indexOf(val) !== -1 || drugItem.pinyinName.indexOf(val.toLocaleUpperCase()) !== -1) {
                            arr.push(drugItem);
                        }
                    }
                    this.drugInfoList = arr;
                    if (this.drugInfoList.length > 0) {
                        flag = false;
                    }
                }
                if (flag) {
                    this.selectLoading = true;
                    // this.selectFilterSetTimeOut = setTimeout(() => {
                    console.log(val);
                    localStorage.setItem('isHideStartLoading', 'Y');
                    _this.getDrugInfoPageList({ drugName: val, pinyinName: val });
                    _this.selectFilterSetTimeOut = null;
                    // }, 500);
                }
            } else if (val == '') {
                console.log('没有搜索条件');
                _this.oldDrugInfoList = [];
                localStorage.setItem('isHideStartLoading', 'Y');
                _this.drugInfoList = _this.oldDrugInfoList;
            }
        },
        // 取货方式过滤
        pickWaysFormat(row, column) {
            return {
                '2': '自提',
                '1': '快递',
            }[row.pickWays] || '-';
        },
        // 是否接受替代厂家过滤
        isChangeFormat(row, column) {
            return {
                '0': '否',
                '1': '是',
            }[row.isChange] || '-';
        },
        // 支付状态过滤
        statusFormat(row, column) {
            // console.log(row,column);
            return {
                '6': '待处理',
                '1': '待支付',
                '2': '已支付',
                '3': '待取货',
                '4': '已完成',
                '5': '已取消',
                '7': '待支付',
            }[row.orderStatus + ''] || '-';
        },
        // 支付状态过滤
        statusFormat2(orderStatus) {
            console.log(orderStatus);

            return {
                '6': '待处理',
                '1': '待支付',
                '2': '已支付',
                '3': '待取货',
                '4': '已完成',
                '5': '已取消',
                '7': '待支付',
            }[orderStatus + ''] || '-';
        },
        clearValidTip(formName) {
            this.$refs[formName].clearValidate();
        },
        // 获取角色设置校验规则
        getRules() {
            return {
                buyPerson: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
                contactPhone: [{ required: true, message: '请输入联系人电话', trigger: 'blur' }],
                drugName: [{ required: true, message: '请选择药品名称', trigger: 'change' }],
                manufacturer: [{ required: true, message: '请输入生产厂家', trigger: 'blur' }],
                agentCount: [{ required: true, message: '请输入数量', trigger: 'blur' }],
                isChange: [{ required: true, message: '请选择是否接受代替厂家', trigger: 'change' }],
                orderMeney: [{ required: true, message: '请输入订单金额', trigger: 'blur' }],
                // pickWays: [{ required: true, message: '请选择取货方式', trigger: 'blur' }],
                pickWays: [
                    {
                        required: true,
                        validator: (rule, value, callback) => { // 0 自提 1快递
                            console.log(value);
                            if (value == '1') {
                                this.form.storeId = '';
                                self.$refs.storeName && self.$refs.storeName.clearValidate();
                                self.$refs.storeAddress && self.$refs.storeAddress.clearValidate();
                                self.pickWaysType = value;
                                callback();
                            } else if (value == '2') {
                                self.$refs.receiver && self.$refs.receiver.clearValidate();
                                self.$refs.receiverPhone && self.$refs.receiverPhone.clearValidate();
                                self.$refs.receiverAddress && self.$refs.receiverAddress.clearValidate();
                                self.preSelectItem = self.$set({ province: '', city: '', area: '', areaCode: '' });
                                // self.$refs.receiver && self.$refs.receiver.clearValidate();
                                self.pickWaysType = value;
                                callback();
                            } else if (!value) {
                                return callback(new Error('请选择取货方式'));
                            }
                        },
                        trigger: 'change'
                    }],
                // storeName: [{ required: true, message: '请选择取货方式', trigger: 'blur' }],
                storeName: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value && self.pickWaysType == '2') {
                                console.log(self);
                                return callback(new Error('请选择提货门店'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ],
                receiver: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value && self.pickWaysType == '1') {
                                return callback(new Error('请输入收货人'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                receiverPhone: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value && self.pickWaysType == '1') {
                                return callback(new Error('请输入联系电话'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                receiverAddress: [
                    {
                        validator: (rule, value, callback) => {
                            if (!value && self.pickWaysType == '1') {
                                return callback(new Error('请输入详细地址'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
            }
        },
        getLogisticsRule() {
            return {
                logisticsCompany: [{ required: true, message: '请输入物流公司', trigger: 'blur' }],
                logisticsNo: [{ required: true, message: '请输入物流单号', trigger: 'blur' }],
            }
        }
    },
}
</script>

<style lang="less" scoped>
.wrap {
}
.boxCard {
    margin-bottom: 20px;
}
.queryBox {
    padding: 20px;
}
.baseInp {
    width: 300px;
}
.dlRole {
    margin-bottom: 10px;
    span {
        color: red;
    }
}

.tabTitle {
    color: #333;
    font-size: 15px;
    margin-right: 30px;
}

.tabBox /deep/ .el-card__header {
    padding: 0;
}
.tabBox /deep/ .el-tabs__header {
    margin: 10px 20px 0;
}
.tabBox /deep/ .el-tabs__nav-wrap::after {
    background-color: transparent;
}

.input-all.el-icon-arrow-down:before,
.input-all.el-icon-arrow-up:before {
    /* content: "\E6DF"; */
    position: absolute;
    right: 5px;
    top: 50%;
    z-index: 100;
    transform: translate(0, -50%);
}
// .tabBox /deep/ .el-radio-button__inner {
//     border: none;
// }
// .tabBox /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
//     position: relative;
//     color: #409eff;
//     background-color: #fff;
//     border-color: #fff;
//     -webkit-box-shadow: none;
//     box-shadow: none;
// }
// .tabBox /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner::after {
//     content: '';
//     position: absolute;
//     bottom: 0;
//     left: 0;
//     width: 100%;
//     height: 2px;
//     background: #409eff;
// }
.addOrder {
    display: block;
    margin: 10px;
}
.myDivider /deep/ .el-divider--horizontal {
    height: 3px;
}
.myDivider /deep/ .el-divider__text {
    font-weight: bold;
    font-size: 16px;
}
.myDivider {
    .state {
        margin-left: 50px;
        font-size: 14px;
        color: red;
    }
}
</style>
